import React, { useEffect, useState } from 'react'
import Carrusel from './Carrusel'
import { Box } from '@mui/material'
const CarruselOrganismos = ({ isOrganismo }) => {
    // obtener datos de empresas para el carrusel
    const [grouped, setGrouped] = useState([]);
    const getEmpresas = async () => {
        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/listado_organismos_carrusel`)
            .then(res => res.json())
            .then((respuesta) => {
                setGrouped(respuesta.data);
            });
    }

    useEffect(() => {
        const init = async () => await getEmpresas();
        init();
    }, []);

    if (grouped.length > 0) {
        return (
            <Box sx={{
                width: '100%', height: '100%', '.slick-arrow': {
                    backgroundColor: '#b3cc57',
                    borderRadius: '30px',
                    scale: '2'
                }
            }}>
                <Carrusel items={grouped} isOrganismo={isOrganismo} />
            </Box>
        )
    }
}

export default CarruselOrganismos